import React from 'react'
import Button, { ButtonType } from '../../Button'
import Icon, { IconType } from '../../Icon'
import style from './VotesError.module.scss'
import { VotesAlertProps, PollsAlertData, VotesErrorType } from './../types'

const VotesError: React.FC<VotesAlertProps> = ({ error, confirmHandler, cancelHandler}) => {

  let data: PollsAlertData
  switch (error) {

    case VotesErrorType.DELETE_CONFIRMATION:
      data = {
        errMsg: 'You are about to remove this poll',
        confirmMsg: 'Are you sure you want to continue?',
        btnText: 'Yes, remove poll',
        btnBdd: 'remove-vote-warning-button',
        cancelBtn: true
      }
      break
    case VotesErrorType.START_NEW_POLL:
      data = {
        errMsg: 'Starting a new poll will end the currently active poll',
        confirmMsg: 'Are you sure you want to continue?',
        btnText: 'Yes, start poll',
        btnBdd: 'start-vote-warning-button',
        cancelBtn: true
      }
      break
    case VotesErrorType.CHANGE_DURING_LIVE:
      data = {
        errMsg: `Poll can't be saved`,
        confirmMsg: 'Changes to polls cannot be made during a live event',
        btnText: 'OK',
        btnBdd: 'live-change-warning-button',
        cancelBtn: false
      }
      break
    case VotesErrorType.DUPLICATE_ANSWER:
      data = {
        errMsg: `Poll can't be saved`,
        confirmMsg: 'You cannot have identical answers',
        btnText: 'OK',
        btnBdd: 'duplicate-answer-warning-button',
        cancelBtn: false
      }
      break
    case VotesErrorType.INSUFFICIENT_DATA:
      data = {
        errMsg: `Poll can't be saved`,
        confirmMsg: 'Please enter a question and at least 2 options to save a poll',
        btnText: 'OK',
        btnBdd: 'insufficient-data-warning-button',
        cancelBtn: false
      }
      break
    case VotesErrorType.SERVER_ERROR:
    default:
      data = {
        errMsg: `Poll can't be saved`,
        confirmMsg: '',
        btnText: 'OK',
        btnBdd: 'vote-server-error-button',
        cancelBtn: false
      }

  }

  return (
    <div className={ style['polls-alert-container']} data-bdd="polls-alert-container">
      <div className={ style['alert-header'] }>
        <div className={ style['alert-icon'] }>
          <Icon name={ IconType.iconName.danger } colour={IconType.colour.white} />
        </div>
        <div className={ style['alert-message'] }>
          { data.errMsg }
        </div>
      </div>
      <div className={ style['alert-confirm-message'] }>
        { data.confirmMsg }
      </div>
      <div className={ style['alert-buttons']}>
        <Button
          type={ ButtonType.buttonType.button }
          onClick={confirmHandler}
          text={ data.btnText }
          dataBdd={ data.btnBdd }
          className={ style['button'] }
        />
        { data.cancelBtn &&
          <Button
            dataBdd='cancel-button'
            type={ ButtonType.buttonType.button }
            onClick={cancelHandler}
            text="Cancel"
            color={ IconType.colour.link}
            className={ `${style['button']} ${style['ml-1']}` }
          />
        }
      </div>
    </div>
  )

}

export default VotesError
